import ru from './ru.json';
import en from './en.json';
import { createI18n } from 'vue-i18n';

export const defaultLocale = 'ru';

const STORAGE_KEY = 'app_locale';

function detectLocale() {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'ru' || stored === 'en') {
        return stored;
    }

    const browserLang = (navigator.language || '').toLowerCase();
    if (browserLang.startsWith('ru')) {
        return 'ru';
    }

    return defaultLocale;
}

function persistLocale(locale) {
    localStorage.setItem(STORAGE_KEY, locale);
}

function getPersistedLocale() {
    return localStorage.getItem(STORAGE_KEY);
}

export { persistLocale, getPersistedLocale, STORAGE_KEY };

export const languages = {
    ru,
    en
};

export const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: detectLocale(),
    fallbackLocale: 'ru',
    messages: Object.assign(languages)
});